export default "__VITE_ASSET__Ds47XW$N__"